import * as Api from '@ViewModels';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Industry } from '../../../../extViewmodels';
import { ILocationState } from '../../../../models';
import { CampaignType } from '../../../../models/AdminModels';
import { useEventLogging } from '../../../../models/Logging';
import { useAdminUserSession } from '../../../../models/hooks/adminStateHooks';
import { useErrorMessages, useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { TemplateCategoriesViewModel, TemplateWithStatusesViewModel } from '../../../../viewmodels/AdminViewModels';
import { CategoriesByIndustry } from '../CategoriesByIndustry';

function _AdminIndustryTemplatesBlogsTabContent({ industry }: { industry: Industry }) {
	const userSession = useAdminUserSession();
	const errorMessages = useErrorMessages();
	const fullscreenModal = useFullscreenModal();
	const { logApiError } = useEventLogging('AdminBlogsTabContent');
	const [categoriesVm] = React.useState(new TemplateCategoriesViewModel(userSession, industry, CampaignType.Blog));
	React.useEffect(() => {
		categoriesVm.load()?.catch((error: Api.IOperationResultNoValue) => {
			logApiError(`LoadCampaignTemplatesTemplateError`, error);
			errorMessages.pushApiError(error);
		});
	}, [categoriesVm, errorMessages, logApiError]);

	const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
		model: null,
		viewModel: categoriesVm,
	};

	return (
		<CategoriesByIndustry
			industry={industry}
			categories={categoriesVm}
			campaignType={CampaignType.Blog}
			onClickNewButton={() =>
				fullscreenModal.history.push({
					pathname: '/campaign-templates/blog-post/edit/new',
					state: locationState,
				})
			}
		/>
	);
}

export const AdminIndustryTemplatesBlogsTabContent = observer(_AdminIndustryTemplatesBlogsTabContent);
